import { render, staticRenderFns } from "./PurchaseInvoices.vue?vue&type=template&id=a46f29f8&scoped=true&"
import script from "./PurchaseInvoices.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoices.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInvoices.vue?vue&type=style&index=0&id=a46f29f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46f29f8",
  null
  
)

export default component.exports